<template>
  <div
    class="border-static-default-mid rounded-md overflow-hidden border px-20"
  >
    <RevList>
      <RevListItemStatic
        v-for="(diagnostic, index) in props.summary"
        :key="`${index}-${diagnostic.answer}`"
      >
        <template #label>
          <p class="body-1">
            {{ diagnostic.question }}
          </p>
        </template>
        <template #suffix>
          <p class="body-1">
            {{ diagnostic.answer }}
          </p>
        </template>
      </RevListItemStatic>
    </RevList>
  </div>
</template>

<script lang="ts" setup>
import { RevList } from '@ds/components/List'
import { RevListItemStatic } from '@ds/components/ListItemStatic'

export interface DeviceSummaryProps {
  summary: Array<{ question: string; answer: string }>
}

const props = withDefaults(defineProps<DeviceSummaryProps>(), {
  summary: () => [],
})
</script>
